module.exports = __webpack_public_path__ + "img/ow-vision-ball.36e9d28b.png";